export { CustomerAcqCompareTool as default } from "./customer-acq-compare-tool";
export type { CustomerAcqCompareToolProps } from "./customer-acq-compare-tool";
